import { ACCESS_TOKEN, REFRESH_TOKEN, USER_NAME } from "../../constant";
import { logoutHandler } from "./mutation";

// React Query hooks for authentication

export const useLogout = () => {
  const mutateAsync = async () => {
    await logoutHandler();
  };

  return {
    mutateAsync,
    isPending: false
  };
};
